<template>
  <dashboard />
</template>

<script>
import Dashboard from "@/views/Dashboard.vue";

export default {
  name: "Dashboard",
  components: {
    Dashboard
  }
};
</script>
